import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AppThunk } from '../../store'; // Adjust the import according to your setup

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const VERSION = process.env.REACT_APP_API_VERSION;

interface SensorDetails {
  participantID: string;
  healthScore: number;
  sensorID: string;
  sensorBattery: number;
  lastSyncTime: string;
  firstSyncTime: string;
  provisionTime: string;
  organizationName: string;
  studyName: string;
  pinnedStatus: boolean;
  syncStatus: string;
}

// Define the initial state for SensorDetails
const initialSensorDetails: SensorDetails[] = [];

const unAnomalousParticipantsDetailsSlice = createSlice({
  name: 'unAnomalousParticipantsDetails',
  initialState: { sensors: initialSensorDetails },
  reducers: {
    // update multiple sensors
    updateSensors: (state, action: PayloadAction<SensorDetails[]>) => {
      state.sensors = action.payload;
    },
    // Remove a specific sensor by sensorID
    removeSensor: (state, action: PayloadAction<string>) => {
      state.sensors = state.sensors.filter(sensor => sensor.sensorID !== action.payload);
    },
    // Clear all sensors
    clearAllSensors: (state) => {
      state.sensors = [];
    },
  },
});

export const { updateSensors, removeSensor, clearAllSensors } = unAnomalousParticipantsDetailsSlice.actions;

export default unAnomalousParticipantsDetailsSlice.reducer;

function mapUnAnomalousParticipantsToSensorDetails(devices: { device_uuid: string, study_participant_id: string, last_sync_time: string, first_sync_time: string, provisioned_time: string, organization_name: string, study_name: string }[]): SensorDetails[] {
  return devices.map(device => ({
    participantID: device.study_participant_id,
    healthScore: 0, 
    sensorID: device.device_uuid,
    sensorBattery: 0,
    lastSyncTime: device.last_sync_time,
    firstSyncTime: device.first_sync_time,
    provisionTime: device.provisioned_time,
    organizationName: device.organization_name,
    studyName: device.study_name,
    pinnedStatus: false,
    syncStatus: ''
  }));
}

export const fetchUnAnomalousParticipantDetails = (): AppThunk => async (dispatch, getState) => {
    const state = getState();
    const { sensors } = state.unAnomalousParticipantsDetails;

    let alreadyInitialized : boolean = false;
  
    // Check if the state is not empty
    if (sensors.length > 0 || alreadyInitialized ) {
      // Data is already present, so skip the API call
      return;
    }
  
    // Make the API call to fetch sensor details
    try {
      const response = await fetch(`${BASE_URL}/getUnAnomalousParticipantsWithStudyDetails`);
      // const data: SensorDetails[] = await response.json();

      if (!response.ok) {
        console.log('Failed to fetch data')
        throw new Error('Failed to fetch data');
      }
      const result = await response.json();

      console.log("UnAnomalous Participants Details:", JSON.parse(result['body']))

      const sensorDetailsArray = mapUnAnomalousParticipantsToSensorDetails(JSON.parse(result['body']));
  
      // Dispatch the action to update the sensors in the store
      dispatch(updateSensors(sensorDetailsArray));

      alreadyInitialized = true;

    } catch (error) {
      console.error('Failed to fetch sensor details:', error);
    }
  };

  export const reloadUnAnomalousParticipantsDetails = (): AppThunk => async (dispatch, getState) => {
    const state = getState();
  
    // Make the API call to fetch sensor details
    try {
      const response = await fetch(`${BASE_URL}/getUnAnomalousParticipantsWithStudyDetails`);
      // const data: SensorDetails[] = await response.json();

      if (!response.ok) {
        console.log('Failed to fetch data')
        throw new Error('Failed to fetch data');
      }
      const result = await response.json();

      console.log("Got new data")

      console.log("UnAnomalous Participants Details:", JSON.parse(result['body']))

      const sensorDetailsArray = mapUnAnomalousParticipantsToSensorDetails(JSON.parse(result['body']));
  
      // Dispatch the action to update the sensors in the store
      dispatch(updateSensors(sensorDetailsArray));

    } catch (error) {
      console.error('Failed to fetch sensor details:', error);
    }
  };
  